import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// `.text-xxs` is a custom class from globals.css, unknown to tailwind-merge's
// default config — it was classified as a text COLOR, so any `cn()` call that
// listed it before `text-muted-foreground` (etc.) silently dropped the size.
//
// The previous fix registered the literal string "text-xxs", which does NOT
// hook into the `text-` prefix tree — the class still resolved as a colour
// and kept being stripped (measured live: 16px headers where 12px was
// written). Group members under a prefix must use the object form.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: ["xxs"] }] } },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
